import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from '@components/layout/Layout';

// Pages
import Home from '@pages/Home';
import About from '@pages/About';
import Products from '@pages/Products';
// import ProductDetails from '@pages/ProductDetails';
import Services from '@pages/Services';
import Membership from '@pages/Membership';
// import MemberCooperatives from '@pages/MemberCooperatives';
import Gallery from '@pages/Gallery';
// import News from '@pages/News';
// import NewsDetails from '@pages/NewsDetails';
import Contact from '@pages/Contact';
import NotFound from './pages/NotFound';

// import FAQ from '@pages/FAQ';


/**
 * Temporary placeholder component for pages we haven't created yet
 */
const Placeholder = ({ title }) => (
  <div className="min-h-screen flex items-center justify-center bg-bukawa-light">
    <div className="text-center">
      <h1 className="text-4xl font-heading font-bold text-bukawa-primary mb-4">
        {title}
      </h1>
      <p className="text-bukawa-gray-600">
        This page is under construction
      </p>
    </div>
  </div>
);

/**
 * Main App Component
 */
function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          {/* Home Page */}
          <Route
            path="/"
            element={<Home />}
          />

          {/* About Page */}
          <Route
            path="/about"
            element={<About title="About Us" />}
            // element={<About />}
          />

          {/* Products */}
          <Route
            path="/products"
            element={<Products title="Products" />}
            // element={<Products />}
          />
          <Route
            path="/products/:id"
            element={<Placeholder title="Product Details" />}
            // element={<ProductDetails />}
          />

          {/* Services */}
          <Route
            path="/services"
            element={<Services title="Services" />}
            // element={<Services />}
          />

          {/* Membership */}
          <Route
            path="/membership"
            element={<Membership title="Membership" />}
            // element={<Membership />}
          />

          {/* Member Cooperatives */}
          <Route
            path="/member-cooperatives"
            element={<Placeholder title="Member Cooperatives" />}
            // element={<MemberCooperatives />}
          />

          {/* Gallery */}
          <Route
            path="/gallery"
            element={<Gallery title="Gallery" />}
            // element={<Gallery />}
          />

          {/* News */}
          <Route
            path="/news"
            element={<Placeholder title="News & Updates" />}
            // element={<News />}
          />
          <Route
            path="/news/:id"
            element={<Placeholder title="News Details" />}
            // element={<NewsDetails />}
          />

          {/* Contact */}
          <Route
            path="/contact"
            element={<Contact title="Contact Us" />}
            // element={<Contact />}
          />

          {/* FAQ */}
          <Route
            path="/faq"
            element={<Placeholder title="FAQs" />}
            // element={<FAQ />}
          />

          {/* 404 Page */}
          <Route
            path="*"
            element={<NotFound title="404 - Page Not Found" />}
            // element={<NotFound />}
          />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;